import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";
// Removed date libraries (not used on this screen)


const TEXT = {
    rechageAmount: "Tiền nạp",
    multiple: "Vòng cược trước khi rút",
    DTCBanCa: 'DTC Bắn Cá',
    DTCSlot: 'DTC Slot',
    DTCCasino: 'DTC Casino',
    DTCGameViet: 'DTC Game Việt',
    DTCTheThao: 'DTC Thể Thao',
    eventStartTime: "Thời gian bắt đầu get dữ liệu",
    eventEndTime: "Thời gian kết thúc get dữ liệu",
}

const SetupCondition = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [maxTurn, setMaxTurn] = useState();
    const [rechageAmount, setRechageAmount] = useState();
    const [multiple, setMultiple] = useState();
    const [dtcBanCa, setDTCBanCa] = useState();
    const [dtcSlot, setDTCSlot] = useState();
    const [dtcCasino, setDTCCasino] = useState();
    const [dtcGameViet, setDTCGameViet] = useState();
    const [dtcTheThao, setDTCTheThao] = useState();
    // No date range on this simplified screen
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            setConfigGame({
                rechageAmount: data?.minDeposit,
                multiple: data?.multiple,
                dtcBanCa: data?.dtcRequirements[3],
                dtcSlot: data?.dtcRequirements[1],
                dtcCasino: data?.dtcRequirements[4],
                dtcGameViet: data?.dtcRequirements[2],
                dtcTheThao: data?.dtcRequirements[5],
            });

            setRechageAmount(data?.minDeposit);
            setMultiple(data?.multiple);
            setDTCBanCa(data?.dtcRequirements[3]);
            setDTCSlot(data?.dtcRequirements[1]);
            setDTCCasino(data?.dtcRequirements[4]);
            setDTCGameViet(data?.dtcRequirements[2]);
            setDTCTheThao(data?.dtcRequirements[5]);
            setMaxTurn(data?.maxDailyTurns);
        } catch (err) {
            // Error handling
        }
    };

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 2: setRechageAmount(e); return;
            case 8: setMultiple(e); return;
            case 3: setDTCBanCa(e); return;
            case 4: setDTCSlot(e); return;
            case 5: setDTCCasino(e); return;
            case 6: setDTCGameViet(e); return;
            case 7: setDTCTheThao(e); return;
            default: return;
        }
        
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);

            if (
                !validNumber(rechageAmount) || !validNumber(multiple) || !validNumber(dtcBanCa) || 
                !validNumber(dtcSlot) || !validNumber(dtcCasino) || !validNumber(dtcGameViet) || 
                !validNumber(dtcTheThao)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }
            setIsShowModalSuccess(true);
            const body = {
                config: {
                    maxDailyTurns: maxTurn,
                    minDeposit: rechageAmount,
                    multiple: multiple,
                    dtcRequirements: {
                        1: dtcSlot,
                        2: dtcGameViet,
                        3: dtcBanCa,
                        4: dtcCasino,
                        5: dtcTheThao,
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            // Error handling
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number > 0;
    }

    const showError = (errorMessage) => {
        messageApi.open({
        type: 'error',
        content: errorMessage,
        });
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInputNumer = (key, defaultValue, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "maxTurn" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        defaultValue={defaultValue}
                        onChange={changeInput}
                        max={max}
                        min={1}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {renderInputNumer(
                                    "rechageAmount",
                                    configGame?.rechageAmount, 
                                    (e) => handleChangeInput(e, 2), 
                                    20000, TEXT.rechageAmount
                                )}

                                {renderInputNumer(
                                    "dtcBanCa",
                                    configGame?.dtcBanCa, 
                                    (e) => handleChangeInput(e, 3), 
                                    100000, TEXT.DTCBanCa
                                )}

                                {renderInputNumer(
                                    "dtcSlot",
                                    configGame?.dtcSlot, 
                                    (e) => handleChangeInput(e, 4), 
                                    100000, TEXT.DTCSlot
                                )}

                                {renderInputNumer(
                                    "dtcCasino",
                                    configGame?.dtcCasino, 
                                    (e) => handleChangeInput(e, 5), 
                                    100000, TEXT.DTCCasino
                                )}

                                {renderInputNumer(
                                    "dtcGameViet",
                                    configGame?.dtcGameViet, 
                                    (e) => handleChangeInput(e, 6), 
                                    100000, TEXT.DTCGameViet
                                )}

                                {renderInputNumer(
                                    "dtcTheThao",
                                    configGame?.dtcTheThao, 
                                    (e) => handleChangeInput(e, 7), 
                                    100000, TEXT.DTCTheThao
                                )}

                                {renderInputNumer(
                                    "multiple",
                                    configGame?.multiple, 
                                    (e) => handleChangeInput(e, 8), 
                                    undefined, TEXT.multiple
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupCondition;
